import { css } from '@emotion/react';

export const modalInputStyle = css`
  caret-color: #d9b244;
  background-color: #f2f2f2;
  border: 1px solid transparent;
  max-height: 36px !important;
`;

export const modalButton = css`
  width: 130px;
  min-width: 130px;
  height: 100%;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 8px;

  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  color: #1a1a29;
  background-color: #d9b244;

  &:disabled {
    background-color: #e2e3e4;
    color: #686a79;
  }
`;

export const modalError = css`
  font-family:
    SF Pro Display,
    sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #ff6e6e;
`;
